export default __webpack_public_path__ + "static/media/game-over-sound.503df35a.mp3";